module.exports = __webpack_public_path__ + "img/2.74d22396.jpg";